export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 9_00.2dc2ab44.jpg";